import { useStaticQuery, graphql } from "gatsby"

export const useGallery = () => {
  const { allSanityPhotos } = useStaticQuery(
    graphql`
      query PhotosQuery {
        allSanityPhotos {
          nodes {
            image {
              asset {
                url
                fluid(maxWidth: 350) {
                  ...GatsbySanityImageFluid
                  src
                }
              }
            }
            title
          }
        }
      }
    `
  )
  return allSanityPhotos.nodes
}
